import { DrawerHeader, DrawerCloseButton } from '@chakra-ui/react'
import { memo } from 'react'

export const Header = memo(() => {
  return (
    <>
      <DrawerCloseButton color="#F5F5F5" _hover={{ color: '#F5F5F5' }} />
      <DrawerHeader bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase">
        AGENDAMENTO DE RETORNO AO CLIENTE
      </DrawerHeader>
    </>
  )
})

Header.displayName = 'Header'
